import { light_smaller, FONT } from './Design.js';
import { GAME_VERSION, numberOfPlayers } from './State.js';

const spalte = (o) => o.offset < 5 ? o.offset : o.offset-5;
const reihe = (o) => o.offset < 5 ? 0 : 1;
const x = (o) => 100+(100*spalte(o))
const y = (o, textY=0) => textY+(reihe(o)*120)
const skinTone = (o) => (9*(o.offset%5))
const playerIconWithText = (o, textY, scene) => {
	scene.add.text(x(o)-10, y(o, textY)+50, '('+(o.displayName || o.keys[0] )+')', FONT);
	return scene.add.image(x(o), y(o, textY), 'heldin', skinTone(o)+4).setScale(2)
}

export class ChooseHeroScene extends Phaser.Scene {

    constructor ()
    {
        super({ key: 'ChooseHeroScene', active: false });
		this.playerOne = undefined;
		this.playerTwo = undefined;
		this.options = [
			{player: 1, keys: ['A'], offset: 0},
			{player: 1, keys: ['B'], offset: 1},
			{player: 1, keys: ['C'], offset: 2},
			{player: 1, keys: ['D'], offset: 3},
			{player: 1, keys: ['E'], offset: 4},
			{player: 2, keys: ['ONE', 'NUMPAD_ONE'], displayName: '1', offset: 5},
			{player: 2, keys: ['TWO', 'NUMPAD_TWO'], displayName: '2', offset: 6},
			{player: 2, keys: ['THREE', 'NUMPAD_THREE'], displayName: '3', offset: 7},
			{player: 2, keys: ['FOUR', 'NUMPAD_FOUR'], displayName: '4', offset: 8},
			{player: 2, keys: ['FIVE', 'NUMPAD_FIVE'], displayName: '5', offset: 9},
		]
    }

    create ()
	{
		this.add.image(400, 300, 'sky');
		if (numberOfPlayers()==2) {
			this.twoPlayer()
		} else {
			this.singlePlayer()
		}

		this.add.text(750,580, 'v.'+GAME_VERSION, light_smaller)
	}

	twoPlayer() {
		
		this.add.text(50, 20, 'Wählt eure Spielfiguren:', FONT);

		var textY = 100
		this.options.forEach(o => {
			const select = () => {
				if (o.player == 1) {
					this.playerOne = o
				} else if (o.player == 2) {
					this.playerTwo = o
				}
			};
			playerIconWithText(o, textY, this).setInteractive().on('pointerup', select, this);

			const img = this.add.rectangle(x(o), y(o, textY+20), 32*2,48*2)
			img.setStrokeStyle(4, 0xff0000);
			o.img = img

			o.keys.forEach(k => this.input.keyboard.on('keydown-' + k, select))
		})

		textY+=240
		this.startBtn = this.add.image(this.game.canvas.width/2-40, textY,'start').setInteractive();

        this.input.keyboard.once('keydown-ENTER', () => this.startGame(), this);
		this.startBtn.once('pointerup', () => this.startGame(), this);
	}

	startGame() {
		if (this.playerOne && this.playerTwo) {
			this.scene.start('TwoPlayerScene', {
				skinTone: skinTone(this.playerOne), skinTone2: skinTone(this.playerTwo)
			})
		}
	}

	update() {
		if (numberOfPlayers()==2) {
			this.startBtn.alpha = 0;
			if (this.playerOne && this.playerTwo) this.startBtn.alpha = 1
			this.options.forEach(o => o.img.alpha = 0)
			if (this.playerOne && this.playerOne.img) this.playerOne.img.alpha = .5
			if (this.playerTwo && this.playerTwo.img) this.playerTwo.img.alpha = .5
		}
	}

	singlePlayer()
	{
        var textY = 100
		this.add.text(50, textY, 'Wähle eine Figur mit der du spielen möchtest', FONT);
		this.options.filter((opt) => opt.player === 2).forEach(o => {
			const playAs = () => {
				this.scene.start('SinglePlayerScene', {skinTone: skinTone(o)})
			};
			playerIconWithText(o, textY, this).setInteractive().on('pointerup', playAs, this);

			o.keys.forEach(k => this.input.keyboard.on('keydown-' + k, playAs))
			
		})

    }

}